import PropTypes from 'prop-types';
import { ChipStyles } from './ModuleWrapper.style';

const ModuleWrapper = ({ children, className }) => {
  return (
    <>
      <div className={`module-wrapper ${className}`}>{children}</div>
      <style jsx>{ChipStyles}</style>
    </>
  );
};

ModuleWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

ModuleWrapper.defaultProps = {
  className: '',
};

export { ModuleWrapper };
